import L from 'leaflet';
const MapMarkerIcon = new L.Icon({
    iconUrl: 'https://www.selfawb.ro/fancourier/images/locker_pin.png',
    iconRetinaUrl: 'https://www.selfawb.ro/fancourier/images/locker_pin.png',
    iconSize: new L.Point(30, 45),
});

export { MapMarkerIcon };